// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"v1-z"};